import { COMMON_ACTION_TYPES, PRE_STUDY_ACTIONS } from "../../_constants";
const INITIAL_STATE = {
    preStudyHeader :{
        id:0,
        plantCode:'',
        factoryCode:'',
        module:'',
        style:'',
        styleVersion:0,
        version:0,
        createdBy:0,
        plantId:0,
        factoryId:0,
        userId:0,
        isLoading:false
    },
    preStudyHeaderActivityDetails:
    {
        isLoading:false,
        preStudyHeaderActivityDetails:[]
    },
    pageState:'',
    gsdCodesList:{ isLoading: false,data: []},
    operationList:{ isLoading: false,data: []},
    elementCategories:{ isLoading: false,data: []},
    elementNames:{ isLoading: false,data: []}
}

const preStudyReducer = (state=INITIAL_STATE,action)=>{
    switch(action.type)
    {
        // Change page state to Search or Create
        case PRE_STUDY_ACTIONS.UPDATE_PAGE_STATE : return {
            ...state,
            pageState:action.data
        }

        // Set pre study header
        case PRE_STUDY_ACTIONS.SET_PRE_STUDY_HEADER_DETAIL : return {
            ...state,
            preStudyHeader:{
                isLoading:false,
                ...action.data
            }
        }

        // Set pre study activity details
        case PRE_STUDY_ACTIONS.SET_PRE_STUDY_HEADER_ACTIVITY_DETAILS : return {
            ...state,
            preStudyHeaderActivityDetails:{
                isLoading:false,
                preStudyHeaderActivityDetails : action.data.StudyPreActivityDetails
            }
        }

        // Get PRE_ACTIVITY_STUDY - SUCCESS
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY+ COMMON_ACTION_TYPES.SUCCESS:return {
            ...state,

            preStudyHeader:{
                isLoading:false,
                ...action.data
            },
            preStudyHeaderActivityDetails:{
                isLoading:false,
                preStudyHeaderActivityDetails : action.data.StudyPreActivityDetails
            }
        }

        // Get PRE_ACTIVITY_STUDY - ERROR
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY+ COMMON_ACTION_TYPES.ERROR:return {
            ...state,

            preStudyHeader:{
                ...state.preStudyHeader,
                isLoading:false
            },
            preStudyHeaderActivityDetails:{
                ...state.preStudyHeaderActivityDetails,
                isLoading:false,
            }
        }

        // Get PRE_ACTIVITY_STUDY - REQUEST
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY+ COMMON_ACTION_TYPES.REQUEST:return {
            ...state,

            preStudyHeader:{
                ...state.preStudyHeader,
                isLoading:true
            },
            preStudyHeaderActivityDetails:{
                ...state.preStudyHeaderActivityDetails,
                isLoading:true,
            }
        }

        // Add PRE_ACTIVITY_STUDY - SUCCESS
        case PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY+COMMON_ACTION_TYPES.SUCCESS:return{
            ...state,
            preStudyHeader:{
                isLoading:false,
                ...action.data
            },
            preStudyHeaderActivityDetails:{
                isLoading:false,
                preStudyHeaderActivityDetails : [...action.data.studyPreActivityDetails]
            }
        }

        // Add PRE_ACTIVITY_STUDY - REQUEST
        case PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY+COMMON_ACTION_TYPES.REQUEST:return{
            ...state,
            preStudyHeader:{
                ...state.preStudyHeader,
                isLoading:true
            },
            preStudyHeaderActivityDetails:{
                ...state.preStudyHeaderActivityDetails,
                isLoading:true,
            }
        }

        // Add PRE_ACTIVITY_STUDY - ERROR
        case PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY+COMMON_ACTION_TYPES.ERROR:return{
            ...state,
            preStudyHeader:{
                isLoading:false,
                ...action.data
            },
            preStudyHeaderActivityDetails:{
                isLoading:false,
                preStudyHeaderActivityDetails : [...action.data.studyPreActivityDetails]
            }
        }

        // GSD Codes - ERROR
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES+ COMMON_ACTION_TYPES.ERROR: return {
            ...state,
            gsdCodesList: {
                isLoading: false,
                data: [],
            }
        };

        // GSD Codes - REQUEST
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES+ COMMON_ACTION_TYPES.REQUEST:return {
            ...state,
            gsdCodesList: {
                isLoading: true,
                data: [],
            }
        };

        // GSD Codes- SUCCESS
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES+COMMON_ACTION_TYPES.SUCCESS: return {
            ...state,
            gsdCodesList: {
                isLoading: false,
                data: action.data
            }
        };

        // Operations List
        // Operations List - ERROR
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS+ COMMON_ACTION_TYPES.ERROR: return {
            ...state,
            operationList: {
                isLoading: false,
                data: [],
            }
        };

        // Operations List - REQUEST
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS+ COMMON_ACTION_TYPES.REQUEST:return {
            ...state,
            operationList: {
                isLoading: true,
                data: [],
            }
        };

        // Operations List- SUCCESS
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS+COMMON_ACTION_TYPES.SUCCESS: return {
            ...state,
            operationList: {
                isLoading: false,
                data: action.data
            }
        };

        // Element Categories
        // Element Categories- ERROR
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY+ COMMON_ACTION_TYPES.ERROR: return {
            ...state,
            elementCategories: {
                isLoading: false,
                data: [],
            }
        };

        // Element Categories - REQUEST
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY+ COMMON_ACTION_TYPES.REQUEST:return {
            ...state,
            elementCategories: {
                isLoading: true,
                data: [],
            }
        };

        // Element Categories- SUCCESS
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY+COMMON_ACTION_TYPES.SUCCESS: return {
            ...state,
            elementCategories: {
                isLoading: false,
                data: action.data
            }
        };

        // Element Names
        // GSD Codes - ERROR
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME+ COMMON_ACTION_TYPES.ERROR: return {
            ...state,
            elementNames: {
                isLoading: false,
                data: [],
            }
        };

        // GSD Codes - REQUEST
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME+ COMMON_ACTION_TYPES.REQUEST:return {
            ...state,
            elementNames: {
                isLoading: true,
                data: [],
            }
        };

        // GSD Codes- SUCCESS
        case PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME+COMMON_ACTION_TYPES.SUCCESS: return {
            ...state,
            elementNames: {
                isLoading: false,
                data: action.data
            }
        };





        default : return state
    }
}

export default preStudyReducer;